import callAPI from '../ApiConfig'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

const getAuthParams = () => ({
    username: cookies.get('user_name'),
    user_id: cookies.get('user_id'),
    account_name: cookies.get('account_name'),
    account_id: cookies.get('account_id'),
    sid: cookies.get('sid'),
    baseurl: cookies.get('baseUrl'),
    id: cookies.get('id'),
})

const arrivalValidityLogs = async (props) => {
    return await callAPI({
        route: "arrival_validity_logs/",
        method: "get",
        signal: props?.signal,
        params: { ...getAuthParams(), ...props?.params },
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    })
}

// Revert a transaction to its state before the arrival-validity check.
// data: { transaction_id }
const revertArrivalValidity = async (props) => {
    return await callAPI({
        route: "arrival_validity_logs/revert",
        method: "post",
        signal: props?.signal,
        data: props?.data,
        params: { ...getAuthParams(), ...props?.params },
        headers: { "Content-Type": "application/json", Accept: "application/json" }
    })
}

const arrivalValidityLogAPI = {
    arrivalValidityLogs: arrivalValidityLogs,
    revertArrivalValidity: revertArrivalValidity,
}
export default arrivalValidityLogAPI
